import React from "react";
import Footer from "../footer/Footer";
import Breadcrumb from "./breacrumb/breadcrumb";
import HeadBar from "./headBar/HeadBar";
import PageHeader from "../pageheader/PageHeader";
import styles from "./TermsService.module.css";
function TermsService() {
  const pathItems = [
    { name: "หน้าหลัก", url: "/" },
    { name: "เงื่อนไขการให้บริการ", url: "/" },
  ];
  return (
    <>
      <div className="global-page">
        <Breadcrumb pathItems={pathItems} />
        <PageHeader titlename={"เงื่อนไขการให้บริการ"} />

        <TermsServiceSection />
      </div>
    </>
  );
}

export function TermsServiceSection() {
  return (
    <section className={styles.detail}>
      <div>
            ประชาชนตกลงใช้บริการของระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ของกระทรวงสาธารณะสุข ตามรายละเอียดการให้บริการที่ระบบฯ กำหนด
            โดยยอมรับและตกลงที่จะผูกพัน
            และปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการ ดังต่อไปนี้
          </div>
          <div>
            <br />
          </div>
          <div>1. คำนิยาม</div>
          <div>
            1.1 “ระบบแพลตฟอร์มดิจิทัล” หรือ “Digital Platform” ผูกพันธุ์ (ระบบฯ)
            หมายความว่า บริการดิจิทัลภาครัฐที่พัฒนา หรือจัดหาและให้บริการ
            โดยกรมวิทยาศาสตร์การแพทย์ โดยมีวัตถุประสงค์ให้ประชาชน
            บุคลาการทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรม ได้แก่
            ผลการตรวจทางเภสัชพันธุศาสตร์ เป็นต้น โดยระบบแพลตฟอร์มดิจิทัล
            “ผูกพันธุ์” แบ่งการใช้งานออกเป็น 2 ระบบ ได้แก่
          </div>
          <div>
            <span className={styles.dot}></span>
            “แอปพลิเคชัน” หรือ “Application” ผูกพันธุ์ หมายความว่า แอปพลิเคชัน
            “ผูกพันธุ์” ตลอดจนโปรแกรมคอมพิวเตอร์ ชุดคำสั่ง หรือแอปพลิเคชันอื่น ๆ
            ที่ต้องใช้หรืออาจใช้ร่วมกัน
            หรือเกี่ยวเนื่องกันกับแอปพลิเคชันดังกล่าว เพื่อการใช้บริการ
            “ผูกพันธุ์” ไม่ว่าจะใช้งานผ่านโทรศัพท์มือถือ แท็บเล็ต เว็บ
            หรือผ่านอุปกรณ์อื่นใดก็ตาม ทั้งนี้ ในกรณีที่ แอปพลิเคชัน “ผูกพันธุ์”
            เปลี่ยนชื่อเป็นอย่างอื่นหรือมีแอปพลิเคชันอื่นรวมอยู่ด้วย
            ให้หมายความรวมถึงแอปพลิเคชันนั้นด้วย
          </div>
          <div>
            <span className={styles.dot}></span>
            “เว็บไซต์” หรือ “website” ผูกพันธุ์ หมายความว่า เว็บไซต์ “ผูกพันธุ์”
            ตลอดจนหน้าเว็บเพจที่ทำขึ้นเพื่อนำเสนอข้อมูลต่าง ๆ ผ่านทางคอมพิวเตอร์
            และอินเทอร์เน็ต โดยมีหลายหน้าที่เชื่อมโยงเข้ากับไฮเปอร์ลิงก์
            เพื่อให้สามารถเปิดไปยังหน้าเพจต่าง ๆ และถูกจัดเก็บไว้ใน www.
            (เวิลด์ไวด์เว็บ) โดยเว็บไซต์ผูกพันธุ์ หรือ
            https://phukphan.dmsc.moph.go.th/ มีไว้เพื่อให้ประชาชน
            บุคลากรทางการแพทย์ สามารถเข้าถึงข้อมูลพันธุกรรมได้
            นอกจากนี้ยังให้เจ้าหน้าที่ห้องปฏิบัติการสามารถเปิดห้องปฏิบัติการของตนเองและสามารถรายงานผลการตรวจทางพันธุกรรมได้
          </div>
          <div>
            1.2 “ข้อมูลส่วนบุคคล” หมายความว่า ข้อมูลส่วนตัว หรือ
            ข้อมูลเกี่ยวกับผู้ใช้บริการ
            ซึ่งทำให้สามารถระบุตัวตนของผู้ใช้บริการได้ไม่ว่าทางตรงหรือทางอ้อม
            ซึ่งรวมถึงข้อมูลทั่วไปของผู้ใช้บริการ ข้อมูลที่ใช้ยืนยันตัวตน
            ข้อมูลชีวมาตรหรือ biometrics (เช่น ลายนิ้วมือ ใบหน้า เป็นต้น)
            ข้อมูลสุขภาพ และข้อมูลส่วนบุคคลอื่นใดเกี่ยวกับผู้ใช้บริการ
            ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล ทั้งนี้
            ไม่รวมถึงข้อมูลเกี่ยวกับผู้ใช้บริการ ในกรณีที่ผู้ใช้บริการถึงแก่กรรม
            และไม่รวมถึงข้อมูลทางสถิติ
            หรือข้อมูลที่ไม่สามารถระบุตัวบุคคลที่เป็นเจ้าของข้อมูลส่วนบุคคลได้
            ซึ่งไม่ถือเป็นข้อมูลส่วนบุคคล
            ตามกฎหมายว่าด้วยการคุ้มครองข้อมูลส่วนบุคคล
          </div>
          <div>
            1.3 “ข้อมูลสุขภาพ” หมายความว่า
            ข้อมูลส่วนบุคคลของผู้ใช้บริการที่มีเนื้อหาเกี่ยวกับสุขภาพ ได้แก่
            ข้อมูลการแพ้ยา ข้อมูลโรควินิจฉัย ข้อมูลการจ่ายยา ข้อมูลวัคซีน
            ข้อมูลหัตถการ ข้อมูลค่าผลตรวจ ทางการแพทย์
            ข้อมูลผลตรวจห้องปฏิบัติและผลสรุปภาพถ่ายทางการแพทย์
            ข้อมูลสุขภาพละเอียดอ่อน เช่น ข้อมูลพันธุกรรม เป็นต้น
            และข้อมูลการเข้ารับบริการการรักษาพยาบาล รวมไปถึงข้อมูลสุขภาพอื่น ๆ
            ที่อาจมีเพิ่มเติมในอนาคต
          </div>
          <div>
            1.4 “ผู้ใช้บริการ” หมายความว่า ผู้ใช้งาน ระบบแพลตฟอร์มดิจิทัล
            “ผูกพันธุ์” แบ่งการใช้งานตามระบบฯ และบทบาทดังต่อไปนี้
          </div>
          <div>
            <span className={styles.dot}></span>
            “ประชาชน” หมายความว่า ผู้ป่วย หรือ บุคคลทั่วไป
            ที่เข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
          </div>
          <div>
            <span className={styles.dot}></span>
            “บุคลากรทางการแพทย์” หมายความว่า ผู้ประกอบวิชาชีพทางการแพทย์ ได้แก่
            แพทย์ เภสัชกรพยาบาล เทคนิคการแพทย์ กายภาพบำบัด แพทย์แผนไทย
            นักสาธารณสุขชุมชน รวมทั้ง
            ผู้ที่มีหน้าที่ในการดูแลรักษาผู้ป่วยในด้านอื่น ๆ
          </div>
          <div>
            <span className={styles.dot}></span>
            “ผู้ปฏิบัติงานในห้องปฏิบัติการ” หมายความว่า
            ผู้มีหน้าที่รับผิดชอบในการดำเนินการวิเคราะห์
            ผลการตรวจทางพันธุกรรมที่โรงพยาบาลได้ทำการส่งตัวอย่างมาที่กรมวิทยาศาสตร์การแพทย์
            ได้แก่ นักเทคนิคการแพทย์ และ นักวิทยาศาสตร์การแพทย์
          </div>
          <div>
            1.5 “โรงพยาบาล” หมายความว่า
            สถานที่รวมตลอดถึงยานพาหนะซึ่งจัดไว้เพื่อการประกอบโรคศิลปะ
            ตามกฎหมายว่าด้วยการประกอบโรคศิลปะ
            การประกอบวิชาชีพเวชกรรมตามกฎหมายว่าด้วยวิชาชีพเวชกรรม
            การประกอบวิชาชีพการพยาบาลและการผดุงครรภ์ตามกฎหมายว่าด้วยวิชาชีพ
            การพยาบาลและการผดุงครรภ์
            การประกอบวิชาชีพทันตกรรมตามกฎหมายว่าด้วยวิชาชีพทันตกรรม
            เทคนิคการแพทย์ตามกฎหมายว่าด้วยวิชาชีพเทคนิค การแพทย์
            การประกอบวิชาชีพการแพทย์แผนไทยและการประกอบวิชาชีพการแพทย์แผนไทยประยุกต์ตามกฎหมายว่าด้วยวิชาชีพการแพทย์แผนไทย
            หรือการประกอบวิชาชีพทางการแพทย์และสาธารณสุขอื่นตามกฎหมายว่าด้วยการนั้น
          </div>
          <div>
            1.6 “ระบบสารสนเทศโรงพยาบาล” หรือ “Hospital Information System: HIS”
            หมายความว่า ระบบการจัดการโรงพยาบาลที่ช่วยในการจัดเก็บ จัดการ
            และส่งต่อข้อมูลจำนวนมากทั้งจากภายใน และภายนอกโรงพยาบาล
            ให้ผู้บริหารสามารถจัดสรรทรัพยากรต่างๆ ของโรงพยาบาลได้อย่างคุ้มค่า
            เพิ่มประสิทธิภาพของการทำงานและการรักษาผู้ป่วยได้อย่างรวดเร็ว
          </div>
          <div>
            1.7 “ระบบรับ-ส่งตัวอย่างเพื่อตรวจวิเคราะห์” หรือ “iLAB PLUS”
            หมายความว่า ระบบรับ-ส่งตัวอย่าง
            เพื่อตรวจวิเคราะห์กรมวิทยาศาสตร์การแพทย์ กระทรวงสาธารณสุข
            โดยผู้ใช้จะแบ่งเป็นสำหรับหน่วยงานผู้ขอรับบริการ
            และสำหรับเจ้าหน้าที่กรมวิทยาศาสตร์การแพทย์
            ซึ่งผู้ขอรับบริการเป็นผู้ส่งตัวอย่างให้กับห้องปฏิบัติการของกรมวิทยาศาสตร์การแพทย์
            จากนั้นจะทำการวิเคราะห์ผลทางห้องปฏิบัติการ
            เมื่อวิเคราะห์ผลเรียบร้อยแล้วจะทำการออกรายงานผล
            รับรองผลการตรวจวิเคราะห์
            และส่งผลการตรวจวิเคราะห์กลับให้ทางผู้ขอรับบริการนั้น ๆ
          </div>
          <div>
            1.8 “ผู้ให้บริการ”
            หมายความหน่วยงานที่มีหน้าที่และ/หรือได้รับมอบหมายในการจัดทำ พัฒนา
            และให้บริการระบบแพลตฟอร์มดิจิทัล“ผูกพันธุ์”
          </div>
          <div>
            <br />
          </div>
          <div>บทนำ</div>
          <div>
            ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” (ระบบฯ) คือ
            แพลตฟอร์มดิจิทัลที่มีจุดประสงค์เพื่อรวบรวมข้อมูลพันธุกรรม
            ที่กรมวิทยาศาสตร์การแพทย์และห้องปฏิบัติการอื่น ๆ ให้บริการ
            และให้ผู้ใช้บริการงานสามารถเข้าถึงผลการตรวจผ่านช่องทางต่าง ๆ เช่น
            เว็บไซต์และแอปพลิเคชัน “ผูกพันธุ์”
            ระเบียนสุขภาพอิเล็กทรอนิกส์ส่วนบุคคล (Personal Health Record: PHR)
            และระบบสารสนเทศของโรงพยาบาล (Hospital Information System: HIS)
            เป็นต้น โดยมีผู้ใช้บริการงานระบบ และบทบาทที่เกี่ยวข้อง ดังนี้
          </div>
          <div>
            1. ประชาชน
            เข้าถึงและแสดงผลการตรวจของตนเองให้บุคลาการทางการแพทย์ที่รักษา
          </div>
          <div>
            2. บุคลาการทางการแพทย์ เข้าถึงและใช้ผลการตรวจของประชาชน
            ประกอบการพิจารณาวินิจฉัย ป้องกัน และรักษาโรคที่เฉพาะบุคคล
            ส่งเสริมการรักษาแบบการแพทย์แม่นยำ (Precision Medicine)
          </div>
          <div>
            3. ผู้ปฏิบัติงานในห้องปฏิบัติการ ได้แก่ นักเทคนิคการแพทย์ และ
            นักวิทยาศาสตร์การแพทย์ ลงข้อมูล ผลการตรวจในระบบแพลตฟอร์มดิจิทัล
            “ผูกพันธุ์”
          </div>
          <div>
            ระบบฯ ถูกออกแบบให้รองรับการเชื่อมต่อ PHR ต่าง ๆ
            ทำให้ประชาชนมีทางเลือกในการเข้าถึงข้อมูลพันธุกรรมมากขึ้น
            และการเชื่อมโยงข้อมูลกับระบบ HIS
            ทำให้สามารถรับ-ส่งข้อมูลพันธุกรรมเข้าสู่ระบบของโรงพยาบาลได้ ดังนั้น
            เพื่อให้ผู้ให้บริการระบบฯ สามารถให้บริการฯ แก่ผู้ใช้บริการได้
            ผู้ใช้บริการจะต้องแสดงเจตนาให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข
            และผู้ให้บริการระบบฯ
            ด้วยการตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
          </div>
          <div>
            ผู้ใช้บริการตกลงที่จะให้กรมวิทยาศาสตร์ กระทรวงสาธารณสุข เก็บรวมรวม
            ใช้ จัดการ และเปิดเผยข้อมูลส่วนบุคคล ของผู้ใช้บริการ
            รวมทั้งข้อมูลสุขภาพ รวมทั้งยินยอมให้ผู้ให้บริการระบบฯ
            และโรงพยาบาลที่เข้าร่วมระบบฯ เก็บรวบรวม ใช้ จัดการ
            และเปิดเผยข้อมูลดังกล่าวเพื่อการดำเนินการตามวัตถุประสงค์ของระบบฯ
          </div>
          <div>
            <br />
          </div>
          <div>การตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน</div>
          <div>
            1. ผู้ใช้บริการจะต้องใช้บริการ
            ตามข้อกำหนดที่ได้ระบุไว้ในเอกสารข้อกำหนดและเงื่อนไขการใช้บริการ
            สำหรับประชาชน ฉบับนี้เท่านั้น
            โดยจะไม่สามารถใช้บริการได้เว้นเสียแต่ว่าผู้ใช้บริการจะทำการตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
          </div>
          <div>
            2. การเข้าใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ถือเป็นการแสดงเจตนาว่าผู้ใช้บริการได้ทำความเข้าใจ
            และตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            อย่างครบถ้วนสมบูรณ์แล้ว
          </div>
          <div>
            3. การตกลงยอมรับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            จะมีผลสมบูรณ์ตามกฎหมาย
          </div>
          <div>
            <br />
          </div>
          <div>การแก้ไขข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน</div>
          <div>
            ผู้ให้บริการระบบดิจิทัลแพลตฟอร์ม “ผูกพันธุ์”
            อาจมีการแก้ไขเปลี่ยนแปลงข้อกำหนดและเงื่อนไข
            การใช้บริการสำหรับประชาชน ตามเหตุอันเห็นสมควร
            โดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า ยกเว้น
            มีเหตุที่อาจเกิดผลกระทบต่อข้อมูลส่วนบุคคล
            การแก้ไขเปลี่ยนแปลงจะมีผลบังคับใช้เมื่อมีการประกาศ
            ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน ที่แก้ไขไว้บนระบบฯ
            ผู้ใช้บริการจะต้องตกลงยอมรับการเปลี่ยนแปลงของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            เพื่อใช้บริการฯ หลังจากมีการเปลี่ยนแปลงข้อกำหนด
            และเงื่อนไขการใช้บริการสำหรับประชาชน
            ผู้ใช้บริการควรตรวจสอบและทำความเข้าใจข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            ที่มีการเปลี่ยนแปลงอย่างถี่ถ้วนระมัดระวัง
            และหากผู้ใช้บริการไม่ประสงค์ที่จะใช้งานระบบฯ ต่อไป
            ภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน ฉบับใหม่
            ผู้ใช้บริการสามารถดำเนินการยกเลิกการใช้งานระบบฯ ได้ ปัจจุบัน
            ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            ถูกทบทวนครั้งล่าสุดเมื่อวันที่ 10 พฤศจิกายน 2566
          </div>
          <div>
            <br />
          </div>
          <div>การคุ้มครองข้อมูลส่วนบุคคล</div>
          <div>
            1. ผู้ให้บริการระบบฯ
            ยึดมั่นและให้ความสำคัญกับการรักษาความเป็นส่วนตัวของผู้ใช้บริการ
            โดยจะจัดให้มีการคุ้มครองข้อมูลส่วนบุคคลของผู้ใช้บริการงานตามเอกสารนโยบายการคุ้มครองข้อมูลส่วนบุคคลของประชาชน
          </div>
          <div>
            2. ผู้ให้บริการระบบฯ
            จะกระทำการโดยระมัดระวังอย่างสูงสุดเพื่อปกป้องข้อมูลของผู้ใช้บริการจากการถูกทำลาย
            หรือบุกรุกโดยผู้ไม่มีสิทธิ์ในการเข้าถึงข้อมูล อย่างไรก็ตาม
            ในปัจจุบันผู้ให้บริการระบบฯ ยังไม่สามารถรับประกัน
            การปกป้องข้อมูลได้อย่างเด็ดขาดจากการถูกทำลายหรือเข้าถึงจากบุคลากรทางการแพทย์หรือบุคคลภายนอก
            ที่ไม่เกี่ยวข้องหรือผู้ไม่หวังดี
          </div>
          <div>
            <br />
          </div>
          <div>คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
          <div>
            ผู้ใช้บริการสามารถค้นหารายละเอียดของบริการฯ
            ได้ผ่านเว็บไซต์หรือแอปพลิเคชันของระบบฯ
            หรือในหนังสือแสดงความยินยอมเข้าร่วมระบบฯ
            คุณสมบัติการใช้งานระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ที่เป็นส่วนหนึ่งของบริการ ประกอบด้วยคุณสมบัติดังนี้
            ซึ่งผู้ใช้บริการสามารถใช้งานได้ตลอด 24 ชั่วโมง (ยกเว้นกรณีที่ระบบฯ
            หยุดให้บริการเป็นการชั่วคราวเพื่อบำรุงรักษาระบบฯ หรือ
            กรณีเกิดเหตุขัดข้อง) ทั้งนี้ ผู้ให้บริการระบบฯ
            อาจเพิ่มเติมคุณสมบัติอื่น
            หรือเปลี่ยนแปลงหรือยกเลิกคุณสมบัติเหล่านี้ได้ในอนาคต
          </div>
          <div>- การลงทะเบียนใช้งานระบบฯ</div>
          <div>- การถอนการลงทะเบียนใช้งานระบบฯ</div>
          <div>- การเลือกโรงพยาบาลสำหรับการรับ-ส่งข้อมูลเข้าสู่ระบบฯ</div>
          <div>- การยกเลิกโรงพยาบาลสำหรับการรับ-ส่งข้อมูลเข้าสู่ระบบฯ</div>
          <div>
            - การอนุญาตให้บุคลากรทางการแพทย์เข้าถึงข้อมูลส่วนบุคคลของตนเอง
          </div>
          <div>
            -
            การเพิกถอนบุคลากรทางการแพทย์ที่สามารถเข้าถึงข้อมูลส่วนบุคคลของตนเอง
          </div>
          <div>
            <br />
          </div>
          <div>บัญชี การลงทะเบียน และการถอนการลงทะเบียน</div>
          <div>
            1.
            ผู้ใช้บริการจะต้องสร้างบัญชีโดยการลงทะเบียนผ่านทางแอปพลิเคชันเพื่อเข้าใช้บริการฯ
            ในการลงทะเบียน
            ผู้ใช้บริการจะต้องเลือกสถานพยาบาลที่ผู้ใช้บริการยินยอมให้นำข้อมูลสุขภาพเข้าสู่ระบบฯ
            จากรายชื่อสถานพยาบาลที่ระบบฯ กำหนดให้เท่านั้น
            โดยข้อมูลสุขภาพผู้ใช้บริการจะถูกนำเข้าระบบฯ โดยปกติทุก 24* ชั่วโมง
            หากความยินยอมผู้ใช้บริการไม่มีเปลี่ยนแปลง
            แพทย์จากสถานพยาบาลที่เข้าร่วมโครงการจะสามารถเข้าถึงข้อมูลสุขภาพของผู้ใช้บริการได้ทันทีต่อเมื่อกำลังรักษาผู้ใช้บริการ
            หรือจะต้องได้รับความยินยอมเป็นรายครั้งจากผู้ใช้บริการ
            โดยสถานพยาบาลที่นำเข้าข้อมูลเป็นผู้กำหนดขั้นตอนดังกล่าว ทั้งนี้
            ผู้ให้บริการระบบฯ
            ไม่สามารถกำกับแพทย์ในการเข้าถึงข้อมูลสุขภาพของผู้ใช้บริการผ่านระบบฯ
            ตามนโยบายข้างต้นได้อย่างเด็ดขาด ผู้ใช้บริการตกลงที่จะใช้บริการฯ
            ด้วยข้อจำกัดดังกล่าว และจะไม่สามารถใช้บริการฯ ได้
            หากผู้ใช้บริการลงทะเบียนด้วยข้อมูลที่ผิดพลาด
          </div>
          <div>
            *หมายเหตุ: ผู้ให้บริการระบบฯ
            ไม่สามารถรับรองได้ว่าข้อมูลของผู้ใช้บริการจะพร้อมสำหรับให้บริการฯ
            ภายในระยะเวลาที่กำหนด
          </div>
          <div>
            2. ผู้ให้บริการระบบฯ ถือว่าการใช้บริการฯ หรือกิจกรรมใด ๆ
            ที่ดำเนินการภายใต้บัญชีดังกล่าวเป็นกิจกรรมที่ผู้ใช้บริการผู้เป็นเจ้าของบัญชีได้ดำเนินการด้วยตนเองทั้งสิ้น
            ทั้งนี้
            เว้นแต่จะมีหลักฐานที่สามารถพิสูจน์ได้ว่าเกิดขึ้นโดยผู้ใช้บริการไม่รับรู้และไม่ยินยอม
            หรือเกิดจากความผิดพลาดของระบบฯ หรือเหตุสุดวิสัย
          </div>
          <div>
            3. ผู้ให้บริการระบบฯ มีสิทธิในการระงับการเข้าใช้งาน
            หรือเพิกถอนบัญชีในระบบฯ
            ของผู้ใช้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
            หากทางผู้ให้บริการระบบฯ
            ตรวจสอบพบว่าผู้ใช้บริการได้ละเมิดหรือกำลังกระทำการอันเป็นการละเมิดข้อกำหนดและเงื่อนไขฯ
          </div>
          <div>
            4. ผู้ใช้บริการสามารถถอนการลงทะเบียนใช้งานระบบฯ ได้
            โดยแพทย์จะไม่สามารถเข้าถึงข้อมูลสุขภาพทั้งหมดของผู้ใช้บริการที่อยู่ในระบบฯ
            ได้อีกต่อไป
            ผู้ใช้บริการตกลงว่าการเพิกถอนการลงทะเบียนและหยุดการใช้บริการฯ
            เป็นการแก้ปัญหาความไม่พึงพอใจใด ๆ กับบริการฯ ทั้งนี้
            การเปลี่ยนแปลงสถานะการเข้าร่วมโครงการของผูใช้
            รวมกับการเลือกและยกเลิกสถานพยาบาลที่ให้ส่งข้อมูลเข้าสู่ระบบฯ
            สามารถทำได้มากสุดวันละ 5 ครั้งเท่านั้น
            หากผู้ใช้บริการประสงค์ที่จะถอนการลงทะเบียน
            แต่ได้ทำธุรกรรมครบจำนวนดังกล่าว
            ผู้ใช้บริการจะสามารถถอนการลงทะเบียนได้ในวันถัดไป
          </div>
          <div>
            5. ผู้ใช้บริการตกลงว่าระบบฯ และผู้ให้บริการระบบฯ
            ไม่มีภาระผูกพันหรือความรับผิดต่อเนื้อหา บริการ หรือกรณีใด ๆ
            ที่เกิดจากหรือเกี่ยวข้องกับแอปพลิเคชันของบุคคลที่สาม
          </div>
          <div>
            6. ผู้ใช้บริการตกลงว่า
            ในขณะที่ความสัมพันธ์ระหว่างผู้ใช้บริการกับแอปพลิเคชันของบุคคลที่สาม
            อาจถูกควบคุมโดยข้อตกลงกับบุคคลที่สามนั้น
            การถอนการติดตั้งและ/หรือหยุดใช้งานแอปพลิเคชันของบุคคลที่สามที่มีความเกี่ยวข้องกับระบบฯ
            เป็นการแก้ปัญหาความไม่พึงพอใจในตัวแอปพลิเคชันหรือเนื้อหาในแอปพลิเคชันของบุคคลที่สาม
          </div>
          <div>การให้บริการของระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
          <div>
            1.
            ผู้ใช้บริการสามารถสร้างบัญชีผู้ใช้โดยการลงทะเบียนผ่านเว็บไซต์หรือแอปพลิเคชัน
            ดังต่อไปนี้
          </div>
          <div>- เว็บไซต์หรือแอปพลิเคชัน “ผูกพันธุ์”</div>
          <div>- แอปพลิเคชัน “หมอพร้อม”</div>
          <div>- แอปพลิเคชัน “OnesID”</div>
          <div>- แอปพลิเคชัน “ThaiD”</div>
          <div>
            และจำเป็นต้องพิสูจน์ตัวตนก่อน
            ถึงจะสามารถเข้าถึงข้อมูลส่วนตัวของตนเองได้
          </div>
          <div>2. ผู้ใช้บริการสามารถเข้าถึงข้อมูลพันธุกรรมของตนเองได้</div>
          <div>
            3.
            ผู้ใช้บริการสามารถเลือกแสดงความยินยอมให้บุคลากรทางการแพทย์เข้าถึงข้อมูลส่วนบุคคลของตนเองได้
            โดยมีรูปแบบดังต่อไปนี้
          </div>
          <div>
            - การแสดงความยินยอมรายครั้ง ผ่านระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            เมื่อบุคลากรทางการแพทย์กดขออนุญาตเข้าถึงข้อมูลพันธุกรรรมของผู้ใช้บริการ
            หากผู้ใช้บริการเลือกให้เข้าถึงข้อมูลดังกล่าว แบบรายครั้ง
            ผู้ใช้บริการจำเป็นจะต้องกดยินยอมให้เข้าถึงข้อมูลดังกล่าวทุกครั้งที่มีการขอเข้าถึง
            แม้ว่าบุคลากรทางการแพทย์ผู้นั้นจะเป็นคนเดียวกันกับผู้ที่ขอเข้าถึงข้อมูลครั้งแรกก็ตาม
          </div>
          <div>
            - การแสดงความยินยอมครั้งเดียว ผ่านระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            เมื่อบุคลากรทางการแพทย์ขออนุญาตเข้าถึงข้อมูลพันธุกรรรมของผู้ใช้บริการ
            หากผู้ใช้บริการเลือกให้เข้าถึงข้อมูลดังกล่าว
            แบบครั้งเดียวจะเป็นการอนุญาตให้บุลคาการทางการแพทย์คนดังกล่าวสามารถเข้าถึง
            ข้อมูลพันธุกรรรมของผู้ใช้บริการได้ตลอดจนกว่าประชาชนจะยกเลิกความยินยอม
          </div>
          <div>
            - การแสดงความยินยอมรายโรงพยาบาล
            เมื่อประชาชนเข้ารับการรักษาในโรงพยาบาลนั้น ๆ
            ผู้ใช้บริการมีสิทธิ์ที่จะอนุญาตให้โรงพยาบาลเข้าถึงและนำเข้าข้อมูลพันธุกรรรมในระบบสารสนเทศโรงพยาบาลกับระบบแพลตฟอร์มดิจิทัล
            “ผูกพันธุ์” หรือไม่อนุญาตก็ได้
          </div>
          <div>
            4.
            ผู้ใช้บริการสามารถเข้าถึงรายชื่อแพทย์ที่ตนเองเป็นคนอนุญาตให้เข้าดูข้อมูลพันธุกรรมและสามารถจัดการยกเลิกสิทธิ์การเข้าถึงข้อมูลของบุคลากรทางการแพทย์ได้
          </div>
          <div>
            5.
            ผู้ใช้บริการสามารถเลือกโรงพยาบาลสำหรับประชาชนที่ต้องการให้ข้อมูลพันธุกรรมของตนเองไปแสดงในโรงพยาบาลที่ตนเองทำการเลือก
          </div>
          <div>
            6. ผู้ใช้บริการจะต้องปรับปรุงข้อมูลบัญชี
            รวมไปถึงข้อมูลส่วนตัวบนบัญชีให้ถูกต้องและเป็นปัจจุบันอยู่ตลอดเวลา
          </div>
          <div>
            7. ผู้ให้บริการระบบฯ ถือว่าการใช้บริการฯ หรือกิจกรรมใด ๆ
            ที่ดำเนินการภายใต้บัญชีดังกล่าวเป็นกิจกรรมที่ผู้ใช้บริการผู้เป็นเจ้าของบัญชีได้ดำเนินการด้วยตนเองทั้งสิ้น
            ทั้งนี้
            เว้นแต่จะมีหลักฐานที่สามารถพิสูจน์ได้ว่าเกิดขึ้นโดยผู้ใช้บริการไม่รับรู้และไม่ยินยอม
            หรือเกิดจากความผิดพลาดของระบบฯ หรือเหตุสุดวิสัย
          </div>
          <div>
            8. ผู้ให้บริการระบบฯ มีสิทธิในการระงับการเข้าใช้งาน
            หรือเพิกถอนบัญชีในระบบฯ
            ของผู้ใช้บริการได้โดยไม่จำเป็นต้องแจ้งให้ทราบล่วงหน้า
            หากทางผู้ให้บริการระบบฯ
            ตรวจสอบพบว่าผู้ใช้บริการได้ละเมิดหรือกำลังกระทำการอันเป็นการละเมิดข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
          </div>
          <div>
            9.
            ผู้ใช้บริการสามารถยกเลิกสิทธิ์การเข้าถึงข้อมูลพันธุกรรมของบุคลากรทางการแพทย์ผ่านระบบฯ
            โดยบุคลากรการแพทย์คนดังกล่าวจะไม่สามารถเข้าถึงข้อมูลพันธุกรรมของผู้ใช้บริการที่อยู่ในระบบฯ
            ได้อีกต่อไป
          </div>
          <div>
            10. ผู้ใช้บริการตกลงว่าระบบฯ และผู้ให้บริการระบบฯ
            ไม่มีภาระผูกพันหรือความรับผิดต่อเนื้อหา บริการ หรือกรณีใด ๆ
            ที่เกิดจากหรือเกี่ยวข้องกับระบบฯ ของบุคคลที่สาม
          </div>
          <div>
            11. ผู้ใช้บริการตกลงว่า
            ในขณะที่ความสัมพันธ์ระหว่างผู้ใช้บริการกับระบบฯ ของบุคคลที่สาม
            อาจถูกควบคุมโดยข้อตกลงกับบุคคลที่สามนั้น
            การถอนการติดตั้งและ/หรือหยุดใช้งานระบบฯ ของบุคคลที่สาม
            ที่มีความเกี่ยวข้องกับระบบฯ เป็นการแก้ปัญหาความไม่พึงพอใจในตัวระบบฯ
            หรือเนื้อหาใน ระบบฯ ของบุคคลที่สาม
          </div>
          <div>
            12. บัญชีของผู้ใช้แต่ละบัญชีในระบบฯ
            สงวนไว้เพื่อการใช้งานเฉพาะและโดยผู้เป็นเจ้าของบัญชีแต่เพียงผู้เดียวเท่านั้น
            ผู้ใช้บริการไม่สามารถโอนสิทธิการใช้งานหรือให้ยืมบัญชีของตนแก่บุคคลอื่นไม่ว่ากรณีใดก็ตาม
          </div>
          <div>
            13. ผู้ให้บริการระบบฯ ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการฯ
            ของผู้ใช้บริการตามที่เห็นสมควร
          </div>
          <div>
            14. ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้องจะอนุญาต
            การใช้งานและการให้บริการระบบฯ
            เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว การให้บริการระบบฯ
            ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ “ตามที่มี” (as available)
            โดยอาจมีข้อบกพร่องรวมอยู่ด้วย ผู้ให้บริการระบบฯ
            ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
          </div>
          <div>
            <br />
          </div>
          <div>
            การเลือกและยกเลิกโรงพยาบาลที่ให้รับ-ส่งข้อมูลเข้าสู่ระบบแพลตฟอร์มดิจิทัล
            “ผูกพันธุ์”
          </div>
          <div>
            ในขั้นตอนการลงทะเบียนระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            จะบังคับให้ผู้ใช้บริการทำการยินยอมให้ระบบฯ
            แลกเปลี่ยนข้อมูลกับระบบสารสนเทศโรงพยาบาลก่อน
            เมื่อลงทะเบียนเข้าใช้งานสำเร็จ หากผู้ใช้บริการไม่ต้องการให้ระบบฯ
            แลกเปลี่ยนข้อมูลกับระบบสารสนเทศโรงพยาบาลแล้ว
            ผู้ใช้บริการสามารถยกเลิกการแลกเปลี่ยนข้อมูลดังกล่าว
            หรือเลือกเฉพาะโรงพยาบาลที่ผู้ใช้บริการต้องการให้ข้อมูลผลการตรวจของตนเองไปอยู่ในระบบสารสนเทศของโรงพยาบาลที่ทำการเลือกได้
          </div>
          <div>ข้อจำกัด</div>
          <div>
            ในการใช้บริการฯ ของระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ผู้ใช้บริการจะต้องไม่มีส่วนร่วมในกิจกรรมต่าง ๆ ดังต่อไปนี้
          </div>
          <div>
            1. กิจกรรมที่เป็นการฝ่าฝืนกฎหมาย คำพิพากษา มติหรือคำสั่งศาล
            หรือมาตรการทางปกครองที่มีผลผูกพัน ทางกฎหมาย
          </div>
          <div>
            2. กิจกรรมอื่นใดที่อาจขัดต่อความสงบเรียบร้อยหรือศีลธรรมอันดีงาม
          </div>
          <div>
            3. กิจกรรมที่เป็นการละเมิดทรัพย์สินทางปัญญา เช่น การละเมิดลิขสิทธิ์
            ชื่อเสียง ความเป็นส่วนตัว เป็นต้น และสิทธิอื่นๆ
            ทั้งหมดของผู้ให้บริการระบบฯ
            และ/หรือบุคคลภายนอกที่มีการมอบให้ตามกฎหมายหรือสัญญา
          </div>
          <div>
            4. กิจกรรมที่ส่งเสริมหรือนำไปสู่การเลือกปฏิบัติโดยเชื้อชาติ สัญชาติ
            เพศ สถานะทางสังคม ถิ่นกำเนิดครอบครัว ลักษณะทางกายภาพ
            สุขภาพหรือโรคประจำตัว และอื่น ๆ
            รวมถึงการแสดงออกที่ชักชวนหรือส่งเสริมให้เกิด การฆ่าตัวตาย
            พฤติกรรมการทำร้ายตัวเองหรือการใช้ยาในทางที่ผิด
          </div>
          <div>
            5. กิจกรรมที่หลีกเลี่ยงเทคโนโลยีใด ๆ ที่ผู้ให้บริการระบบฯ
            ผู้ที่ได้รับอนุญาต หรือบุคคลที่สามใด ๆ ใช้เพื่อ
            ปกป้องเนื้อหาหรือบริการฯ
          </div>
          <div>
            6. กิจกรรมที่อาจทำให้ผู้อื่นเกิดความเข้าใจผิดเกี่ยวกับระบบฯ
            บริการของระบบฯ และ/หรือบุคคลภายนอก หรือการจงใจเผยแพร่ข้อมูลเท็จ
          </div>
          <div>
            7. กิจกรรมที่มีการแลกเปลี่ยนสิทธิในการใช้บริการฯ
            หรือเข้าถึงเนื้อหาเพียงบางส่วนหรือทั้งหมดเป็นเงินสด
            ทรัพย์สินหรือผลประโยชน์ใด ๆ
          </div>
          <div>
            8. กิจกรรมที่มีการใช้บริการฯ เพื่อการซื้อขาย การตลาด โฆษณา การชักชวน
            การได้มาซึ่งผลประโยชน์ส่วนตน หรือวัตถุประสงค์ทางการค้าอื่น ๆ
            รวมถึงกิจกรรมที่ใช้บริการฯ เพื่อวัตถุประสงค์ในการคุกคาม
            หรือหมิ่นประมาท หรือกิจกรรมที่ใช้บริการฯ
            เพื่อวัตถุประสงค์อื่นใดที่ไม่ใช่จุดประสงค์ที่แท้จริงของการให้บริการระบบฯ
          </div>
          <div>
            9. กิจกรรมที่นำไปสู่การเก็บรวบรวม การเปิดเผย การทำสำเนา การส่งต่อ
            การทำซ้ำ หรือการแก้ไข บิดเบือน ข้อมูลส่วนบุคคลซึ่งเป็นเนื้อหาบนระบบฯ
            รวมไปถึงการทำสำเนา โดยไม่ได้รับความเห็นชอบ
            จากเจ้าของข้อมูลส่วนบุคคลและ/หรือผู้ให้บริการระบบฯ
            หรือไม่ชอบด้วยกฎหมาย
          </div>
          <div>
            10. กิจกรรมที่แทรกแซงเครื่องแม่ข่าย และ/หรือระบบเครือข่ายของระบบฯ
            กิจกรรมซึ่งเป็นการใช้บริการฯ ในทางที่ผิดด้วยการใช้บ็อท (BOTs)
            เครื่องมือเพื่อการโกง หรือวิธีการทางเทคนิคใด ๆ
            กิจกรรมที่ใช้ข้อบกพร่องหรือข้อผิดพลาดของบริการฯ
            โดยไตร่ตรองไว้ก่อนแล้ว
          </div>
          <div>
            11. กิจกรรมการตรวจสอบ สแกน หรือทดสอบจุดอ่อนของระบบฯ หรือเครือข่ายใด
            ๆ
          </div>
          <div>
            12.
            กิจกรรมฝ่าฝืนหรือหลีกเลี่ยงการรักษาความปลอดภัยหรือมาตรการตรวจสอบตัวตน
          </div>
          <div>
            13. กิจกรรมเข้าถึง ก้าวก่าย หรือใช้บริการฯ หรือ เนื้อหาใด ๆ
            ซึ่งไม่เป็นไปตามขอบเขตการใช้งานของผู้ใช้บริการงาน
            และวัตถุประสงค์ของระบบฯ
          </div>
          <div>
            14. กิจกรรมที่ส่งเสริมหรือช่วยเหลือกิจกรรมใด ๆ ที่กล่าวไว้ข้างต้น
          </div>
          <div>
            15. กิจกรรมที่ขัดแย้งกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            นี้ ตามที่ ผู้ให้บริการระบบฯ กำหนดไว้
          </div>
          <div>16. กิจกรรมอื่น ๆ ที่ผู้ให้บริการระบบฯ เห็นว่าไม่เหมาะสม</div>
          <div>
            <br />
          </div>
          <div>ความรับผิดชอบของผู้ใช้บริการ</div>
          <div>
            1. ผู้ใช้บริการจะต้องใช้บริการฯ
            โดยถือเป็นความเสี่ยงของผู้ใช้บริการเอง
            และจะต้องเป็นผู้รับผิดชอบแต่เพียงผู้เดียวสำหรับการกระทำ/กิจกรรมที่ได้ทำไป
            รวมถึงผลของการกระทำที่มีต่อบริการฯ นี้ด้วย
          </div>
          <div>
            2. ข้อมูลการเข้าใช้งานระบบฯ และกิจกรรมใดๆ
            ที่เกิดขึ้นขณะผู้ใช้เข้าใช้งานระบบฯ
            เป็นความรับผิดชอบของผู้ใช้เองทั้งหมด
          </div>
          <div>
            3. ผู้ให้บริการระบบฯ อาจใช้มาตรการที่เห็นว่าจำเป็นและเหมาะสม
            หากผู้ให้บริการระบบฯ พบว่าผู้ใช้บริการรายใดกำลังใช้บริการฯ
            ในทางที่ฝ่าฝืนข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            อย่างไรก็ตาม ผู้ให้บริการระบบฯ
            จะไม่รับผิดชอบในการแก้ไขหรือป้องกันการฝ่าฝืนดังกล่าว
          </div>
          <div>
            4. ในกรณีที่การใช้บริการฯ
            ของผู้ใช้บริการก่อให้เกิดความเสียหายแก่ระบบฯ หรือผู้ให้บริการระบบฯ
            หรือถูกเรียกเก็บค่าใช้จ่ายใด ๆ (รวมถึงแต่ไม่จำกัดเพียงค่าทนายความ)
            ทั้งทางตรงและทางอ้อม
            (รวมถึงแต่ไม่จำกัดเพียงกรณีที่มีบุคคลภายนอกฟ้องร้องเรียกค่าเสียหายจากผู้ให้บริการระบบฯ
            )
            อันเนื่องมาจากการที่ผู้ใช้บริการฝ่าฝืนข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            หรือฝ่าฝืนกฎหมายที่เกี่ยวข้องขณะใช้บริการฯ
            ผู้ใช้บริการจะต้องทำการรับผิดชอบต่อความเสียหาย/ชดใช้ค่าเสียหายด้วยตนเอง
            โดยไม่เกี่ยวข้องกับผู้ให้บริการระบบฯ แต่อย่างใด
            ผู้ใช้บริการรับทราบว่าการชดใช้ค่าเสียหายเพียงอย่างเดียวอาจไม่เพียงพอต่อการเยียวยาความเสียหายอันเกิดจากการฝ่าฝืนกฎหมายและ/หรือละเมิดข้อกำหนดและเงื่อนไขฯ
            ฉบับนี้ ผู้ให้บริการระบบฯ
            มีสิทธิได้รับการเยียวยาความเสียหายจากการกระทำการหรืองดเว้นกระทำการอื่นใดได้ตามความเหมาะสม
          </div>
          <div>
            5. ผู้ใช้บริการยอมรับที่จะปฏิบัติตาม ข้อจำกัด และจะไม่ใช้บริการ
            เนื้อหาของระบบฯ หรือส่วนใดที่กล่าวมาข้างต้น
            ในลักษณะใดก็ตามที่ไม่ได้รับอนุญาตอย่างชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            ผู้ให้บริการระบบฯ ไม่ให้สิทธิ์ ชื่อ
            หรือผลประโยชน์ใดก็ตามแก่ผู้ใช้บริการในบริการ หรือเนื้อหาของระบบฯ
            ยกเว้นสิทธิ์ที่ได้รับอนุญาตโดยชัดเจนในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
          </div>
          <div>การให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”</div>
          <div>
            ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ขอสงวนสิทธิ์ในการจำกัดการเข้าถึงบริการระบบฯ
            ของผู้ใช้บริการตามที่เห็นสมควรผู้ให้บริการระบบฯ
            ขอสงวนสิทธิ์ในการเพิ่มเติม เปลี่ยนแปลง หรือยกเลิกการให้บริการฯ
            เพียงบางส่วนหรือทั้งหมดโดยไม่จำเป็นต้องแจ้งให้ผู้ใช้บริการทราบล่วงหน้า
            ผู้ใช้บริการยอมรับว่า เท่าที่กฎหมายที่เกี่ยวข้อง จะอนุญาต
            การใช้งานและการให้บริการระบบฯ
            เป็นความเสี่ยงของผู้ใช้บริการแต่เพียงฝ่ายเดียว การให้บริการระบบฯ
            ถูกจัดทำขึ้น “ตามสภาพ” (as is) และ “ตามที่มี” (as available)
            โดยอาจมีข้อบกพร่องรวมอยู่ด้วย ผู้ให้บริการระบบฯ
            ไม่มีการรับประกันโดยนัยใด ๆ ทั้งสิ้น
          </div>
          <div>
            <br />
          </div>
          <div>การยกเว้นความรับผิดชอบ</div>
          <div>
            1. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ไม่สามารถรับประกันไม่ว่าจะอย่างชัดแจ้งหรือโดยปริยายว่า การให้บริการฯ
            (รวมถึงข้อมูลส่วนบุคคล)
            จะปราศจากข้อผิดพลาดหรือข้อบกพร่องตามจริงหรือตามกฎหมาย ซึ่งอาจรวมถึง
            เสถียรภาพ การไว้วางใจได้ ความน่าเชื่อถือ ความถูกต้อง
            ความครบถ้วนสมบูรณ์ การมีประสิทธิผล ความเหมาะสมในการใช้บริการฯ
            เพื่อวัตถุประสงค์เฉพาะ จุดบกพร่องที่เกี่ยวข้องกับความปลอดภัย (bug)
            หรือการละเมิดสิทธิต่างๆ และผู้ให้บริการระบบฯ
            จะไม่รับผิดชอบในการจัดหาบริการฯ
            ที่ไม่มีข้อผิดพลาด/ข้อบกพร่องดังกล่าว แต่จะจัดหาบริการฯ
            ที่ดีที่สุดตามความเหมาะสม
          </div>
          <div>
            2. ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ไม่สามารถรับรองได้ว่าผู้ใช้บริการจะได้รับผลประโยชน์
            ตามวัตถุประสงค์ของระบบฯ เมื่อผู้ใช้บริการใช้บริการฯ
            นอกจากนี้ผู้ให้บริการระบบฯ
            ไม่สามารถรับประกันได้ด้วยว่าบุคลากรทางการแพทย์
            ผู้ปฏิบัติการในห้องปฏิบัติการ และผู้ดูแลระบบฯ ฝั่งโรงพยาบาล
            (Hospital Administrator)
            จะปฏิบัติตามข้อกำหนดและเงื่อนไขการใช้บริการสำหรับผู้ดูแลระบบฯ
            ฝั่งโรงพยาบาล ดังนั้น ผู้ให้บริการระบบฯ จะไม่รับผิดชอบข้อผิดพลาดใด ๆ
            ที่เกิดจากการปฏิบัติหรือไม่ปฏิบัติตามข้อกำหนดและเงื่อนไขของการใช้งานของผู้ใช้บริการดังกล่าว
          </div>
          <div>
            3. ผู้ให้บริการระบบระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์”
            ไม่รับรองว่าผู้ใช้บริการจะสามารถใช้งานบริการฯ
            ร่วมกับเครื่องคอมพิวเตอร์หรืออุปกรณ์อิเล็กทรอนิกส์ทุกชนิดของผู้ใช้บริการ
            รวมไปถึงการที่ผู้ให้บริการระบบฯ จะให้บริการฯ
            โดยปราศจากไวรัสคอมพิวเตอร์ วอร์ม หรือ ม้าโทรจัน (Trojan Horse)
            และผู้ให้บริการระบบฯ จะไม่รับผิดชอบชดใช้ต่อความเสียหายใด ๆ
            ที่เป็นผลมาจากตัวทำลายเหล่านั้น
          </div>
          <div>
            4. ผู้ให้บริการระบบฯ ไม่มีความจำเป็นต้องรับผิดชอบต่อค่าเสียหายใด ๆ
            ที่เกิดขึ้นกับผู้ใช้บริการ ในการใช้หรือไม่สามารถใช้บริการฯ แบบใด ๆ
            หรือเนื่องจากเหตุใดก็ตาม ข้อจำกัดมีผลบังคับใช้เสมอ ไม่ว่า
            ผู้ให้บริการระบบฯ
            จะได้รับทราบหรือควรตระหนักถึงความเป็นไปได้ของความเสียหายดังกล่าว
            ในเขตอำนาจศาลที่ไม่อนุญาตให้ยกเว้นหรือจำกัดความรับผิดชอบต่อความเสียหายที่เป็นผลสืบเนื่องหรือเกิดขึ้นโดยไม่ได้ตั้งใจ
            การรับผิดชอบของผู้ให้บริการระบบฯ
            จำกัดแค่ขอบเขตสูงสุดที่กฎหมายอนุญาตเท่านั้น
          </div>
          <div>
            5. ผู้ให้บริการระบบฯ จะไม่ต้องรับผิดชอบต่อค่าเสียหายโดยอ้อม
            ค่าเสียหายพิเศษ ค่าเสียหายเนื่องจากการผิดสัญญา
            ค่าเสียหายต่อเนื่องหรือค่าเสียหายเชิงลงโทษใด ๆ
            ในส่วนที่เกี่ยวข้องกับการผิดสัญญาหรือการกระทำการละเมิด
            อันเนื่องมากจากความประมาทของผู้ให้บริการระบบฯ เอง
            การชดใช้ค่าเสียหายตามปกติในส่วนที่เกี่ยวข้องกับ
            การผิดสัญญาหรือการกระทำละเมิดจากการเลินเล่อของผู้ให้บริการระบบฯ
            จะเป็นไปตามความเหมาะสม ของการพิจารณาตามกฎหมาย
          </div>
          <div>
            <br />
          </div>
          <div>ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” และหน่วยงานของบุคคลที่สาม</div>
          <div>
            ระบบแพลตฟอร์มดิจิทัล “ผูกพันธุ์” ทำงานร่วมกับ
            หรืออาจมีการโต้ตอบในลักษณะหนึ่งกับแพลตฟอร์มเช่น แอปพลิเคชัน เว็บไซต์
            ระบบสารสนเทศโรงพยาบาล ของบุคคลที่สาม และอุปกรณ์ของบุคคลที่สาม
            เพื่อให้ผู้ใช้บริการ สามารถเข้าถึงบริการฯได้
            โดยแพลตฟอร์มและอุปกรณ์ของบุคคลที่สามเหล่านี้
            อาจมีข้อกำหนดและเงื่อนไขในการใช้งาน
            และนโยบายการคุ้มครองข้อมูลส่วนบุคคลของตัวเอง และการใช้งานระบบฯ
            และอุปกรณ์ของบุคคลที่สามเหล่านี้
            ถูกควบคุมและเป็นไปตามข้อกำหนดเงื่อนไขและนโยบายการคุ้มครองข้อมูลส่วนบุคคลดังกล่าว
            ผู้ใช้บริการเข้าใจ และยอมรับว่าผู้ให้บริการระบบฯ
            ไม่ได้เป็นผู้สนับสนุนและไม่ได้รับผิดชอบ หรือมีความรับผิดในพฤติกรรม
            คุณลักษณะ หรือเนื้อหาของระบบฯหรืออุปกรณ์ของบุคคลที่สามใด ๆ
            หรือธุรกรรมที่ผู้ใช้บริการอาจป้อนให้แก่ผู้ให้บริการของระบบฯ
            และอุปกรณ์ของบุคคลที่สามดังกล่าว รวมถึงไม่รับประกันความเข้ากันได้
            หรือความเข้ากันได้อย่างต่อเนื่องของระบบฯ
            และอุปกรณ์ของบุคคลที่สามกับบริการฯ
          </div>
          <div>
            สิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบแพลตฟอร์มดิจิทัล
            “ผูกพันธุ์”
          </div>
          <div>
            ในการพิจารณาสิทธิ์ที่ผู้ใช้บริการมอบให้ผู้ให้บริการระบบฯ
            ภายใต้ข้อกำหนดและเงื่อนไขฯ ผู้ใช้บริการ
            ได้ให้สิทธิ์ผู้ให้บริการระบบฯ ในการให้บริการฯ ใช้ระบบประมวลผล
            แบนด์วิดธ์ และ ฮาร์ดแวร์ที่ใช้เก็บข้อมูลบนอุปกรณ์ ของผู้ใช้บริการ
            เพื่อเป็นการอำนวยความสะดวกในการปฏิบัติการของบริการฯ
          </div>
          <div>
            การยกเลิกสิ้นสุดข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
          </div>
          <div>
            ผู้ให้บริการระบบฯ อาจทำการยกเลิกข้อกำหนดและเงื่อนไขฯ
            เหล่านี้เมื่อใดก็ได้ตามเหตุอันเห็นสมควรโดยอาจแจ้งให้ผู้ใช้บริการทราบผ่านทางเว็บไซต์หรือแอปพลิเคชัน
            “ผูกพันธุ์” และการยกเลิกสิ้นสุดจะมีผลทันที ณ ขณะนั้น
          </div>
          <div>
            <br />
          </div>
          <div>การโอนสิทธิ์</div>
          <div>
            1. ผู้ให้บริการระบบฯ
            อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            และสิทธิ์ใดก็ตามที่มีภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            ฉบับนี้ ทั้งหมดหรือบางส่วน อีกทั้ง ผู้ให้บริการระบบฯ
            อาจมอบหมายภาระผูกพันภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชนนี้ได้
          </div>
          <div>
            2. ผู้ใช้บริการระบบฯ
            ไม่อาจโอนสิทธิ์ในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชนทั้งหมด
            หรือบางส่วน หรือถ่ายสิทธิ์
            หรืออนุญาตให้ใช้สิทธิ์ต่อภายใต้ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชนนี้แก่บุคคลที่สามใดก็ตาม
          </div>
          <div>การเป็นโมฆะบางส่วน การละเว้น และ การตีความ</div>
          <div>
            เว้นแต่ได้ระบุไว้เป็นอื่นในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            นี้
            ข้อกำหนดข้อหนึ่งข้อใดในข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            จะตกเป็นโมฆะหรือไม่มีอำนาจบังคับใช้ได้ด้วยเหตุผลใดก็ตาม
            หรือภายในขอบเขตใด ๆ
            การเป็นโมฆะหรือการไม่มีอำนาจบังคับใช้นั้นจะไม่มีผลต่อ
            หรือส่งผลให้ข้อกำหนดที่เหลือ
            ของข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน นี้เป็นโมฆะ
            หรือไม่มีอำนาจบังคับใช้ด้วย ไม่ว่าในกรณีใดก็ตาม
            และการบังคับใช้ข้อกำหนดดังกล่าวจะต้องมีผลใช้ภายในขอบเขตที่ชอบโดยกฎหมาย
            รวมถึงจะไม่มีการละเว้นสิทธิ์ ของผู้ให้บริการระบบฯ
            หรือบุคคลที่สามผู้รับผลประโยชน์จากข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน
            ฉบับนี้
          </div>
          <div>
            ตามที่ใช้ในข้อกำหนดเหล่านี้ คำว่า “รวม” และ “รวมถึง” และ
            การหลากคำข้างต้น จะถือว่ามีคำว่า “ไม่มีข้อจำกัด” ตามมาด้วย
          </div>
          <div>
            <br />
          </div>
          <div>กฎหมายที่บังคับและขอบเขตอำนาจ</div>
          <div>
            ข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน นี้
            (รวมถึงข้อพิพาท/การเรียกร้องความเสียหาย
            ที่ไม่ได้ระบุในข้อกำหนดและเงื่อนไขฯ
            ซึ่งเกิดจากหรือเกี่ยวเนื่องกับข้อกำหนดและเงื่อนไขการใช้บริการสำหรับประชาชน)
            จะใช้บังคับกับความสัมพันธ์ระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
            โดยจะอยู่ภายใต้การบังคับใช้กฎหมายของประเทศไทย
            ผู้ใช้บริการตกลงที่จะระงับข้อพิพาทนอกศาลโดยติดต่อผู้ให้บริการระบบฯ
            หากข้อพิพาทดังกล่าวไม่สามารถยุติได้
            ผู้ใช้บริการถึงจะสามารถนําคดีขึ้นสู่ศาลได้ นอกจากนั้น
            ผู้ใช้บริการและผู้ให้บริการระบบฯ เห็นชอบให้การระงับข้อพิพาท
            การเรียกร้องความเสียหาย หรือความขัดแย้งที่อาจเกิดขึ้นจากบริการฯ
            หรือเกิดขึ้นระหว่างผู้ใช้บริการและผู้ให้บริการระบบฯ
            ที่เกี่ยวกับบริการฯ อยู่ภายใต้เขตอำนาจของศาลประเทศไทย
          </div>
          <div>
            <br />
          </div>
          <div>การแจ้งเตือนและการติดต่อ</div>
          <div>
            เมื่อผู้ให้บริการระบบฯ
            มีความประสงค์ที่จะแจ้งเตือนหรือติดต่อผู้ใช้บริการเกี่ยวกับการบริการฯ
            ผู้ให้บริการระบบฯ
            อาจทำการติดต่อไปยังผู้ใช้บริการโดยตรงหรือผ่านหน่วยงานฯ
            ตามที่เห็นสมควรในแต่ละกรณี เช่นเดียวกัน
            หากผู้ใช้บริการมีความประสงค์ที่จะแจ้งปัญหาหรือติดต่อ
            เกี่ยวกับการบริการฯ สามารถติดต่อผู้ให้บริการระบบฯ
            ตามข้อมูลที่ปรากฎตามด้านล่างนี้
          </div>
          <div>
            <br />
          </div>
          <div>ช่องทางการติดต่อ</div>
          <div>
            หากประชาชนประสงค์จะติดต่อ หรือมีข้อสงสัย
            หรือต้องการสอบถามข้อมูลเกี่ยวกับรายละเอียด การเก็บรวบรวม ใช้
            และ/หรือเปิดเผยข้อมูลส่วนบุคคล รวมถึงสิทธิของประชาชนนโยบายฉบับนี้
            หรือต้องการยกเลิกการให้ความยินยอมในการเก็บรวบรวม ใช้
            และ/หรือเปิดเผยข้อมูลส่วนบุคคล
            หรือกรณีที่พบว่ามีการใช้ข้อมูลส่วนบุคคลของประชาชนไปในทางที่ไม่ชอบ
            ประชาชนสามารถติดต่อสำนักงาน ทางช่องทางดังต่อไปนี้
          </div>
          <div>
            <br />
          </div>
          <div>สถาบันชีววิทยาศาสตร์ทางการแพทย์ กรมวิทยาศาสตร์การแพทย์</div>
          <div>
            สถานที่ติดต่อ: 88/7 ซอยบำราศนราดูร ถ.ติวานนท์ ต.ตลาดขวัญ อ.เมือง
            จ.นนทบุรี 11000
          </div>
          <div>เวลาทำการปกติ: วันจันทร์ถึงศุกร์ เวลา 8:30 – 16:30 น.</div>
          <div>เว็บไซต์: https://phukphan.dmsc.moph.go.th/</div>
          <div>
            <br />
          </div>
          <div>ติดต่อสอบถาม :</div>
          <div>นางสาวพรนภัส อยู่นุช</div>
          <div>อีเมลล์: pornnapat.y@dmsc.mail.go.th</div>
          <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
          <div>นายพนาพัฒน์ ไพเราะ</div>
          <div>อีเมลล์: panapat.p@dmsc.mail.go.th</div>
          <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99394</div>
          <div>นางสาวนภัชชา ถาวงศ์</div>
          <div>อีเมลล์: penpitcha.t@dmsc.mail.go.th</div>
          <div>หมายเลขโทรศัพท์: 0-2589-9850 ถึง 8 ต่อ 98096</div>
          <div>นายอาคม สาลี</div>
          <div>อีเมลล์: arkom.s@dmsc.mail.go.th</div>
          <div>หมายเลขโทรศัพท์: 0-2951-0000 ต่อ 99460</div>
    </section>
  );
}

export default TermsService;
